import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { validateSession, clearSession } from '../login/page';
import Sidebar from './components/Sidebar';
import DashboardHeader from './components/DashboardHeader';
import FinancialSummary from './components/FinancialSummary';
import LatestAnnouncements from './components/LatestAnnouncements';
import UpcomingMeetings from './components/UpcomingMeetings';

export default function Dashboard() {
  const navigate = useNavigate();

  useEffect(() => {
    // Validate session on component mount
    if (!validateSession()) {
      navigate('/login');
      return;
    }

    // Set up session validation interval (check every minute)
    const sessionCheckInterval = setInterval(() => {
      if (!validateSession()) {
        clearSession();
        navigate('/login');
      }
    }, 60000); // Check every 60 seconds

    return () => {
      clearInterval(sessionCheckInterval);
    };
  }, [navigate]);

  return (
    <div className="flex min-h-screen bg-gray-50">
      <Sidebar />
      <div className="flex-1 flex flex-col">
        <DashboardHeader />
        <main className="flex-1 p-8">
          <div className="max-w-7xl mx-auto">
            <h1 className="text-3xl font-bold text-gray-900 mb-8">Dashboard Overview</h1>
            
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8">
              <FinancialSummary />
            </div>

            <div className="grid grid-cols-1 gap-6 mb-6">
              <LatestAnnouncements />
            </div>

            <div className="mt-6">
              <UpcomingMeetings />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
